import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import styles from './Winnings.module.scss';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import Paragraph from '../../../components/Typography/Paragraph/Paragraph';
import WinningCard from './WinningCard/WinningCard';
import Button from '../../../components/Button/Button';
import Table from '../../HorseView/TableRace/Table';
import moment from 'moment';
import Heading from '../../../components/Typography/Heading/Heading';
import Horse from '../../../assets/icons/horse.webp';
import Jockey from '../../../assets/icons/jockey.webp';
import { ReactComponent as AdaBigIcon } from '../../../assets/icons/icon-ada-big.svg';
const pageOptions = [
    { name: 'all', value: 'all' },
    { name: 'unclaimed', value: 'unclaimed' },
    { name: 'claimed', value: 'claimed' }
];
const columns = [
    { label: 'date', accessor: 'date' },
    { label: 'location', accessor: 'location' },
    { label: '', accessor: 'img' },
    { label: 'racehorse', accessor: 'racehorse' },
    { label: 'place', accessor: 'place' },
    { label: 'prize', accessor: 'prize' },
    { label: '', accessor: 'btn' }
];
const chart = [
    {
        id: 1,
        time: '1m 22.53s',
        gate: 2,
        horse: 'Five Rings',
        jockey: 'Malik (Wise)',
        class: 3,
        place: 1,
        stable: "Thor's Breeding",
        guild: 'Mamba Forever',
        date: '02/02/2023',
        location: 'Prague, CZ',
        eventInfo: 'GOLDEN OAKS DAY DASH',
        prize: 60,
        claimed: true
    },
    {
        id: 2,
        time: '1m 22.53s',
        gate: 2,
        horse: 'Five Rings',
        jockey: 'Malik (Wise)',
        class: 3,
        place: 2,
        stable: "Thor's Breeding",
        guild: 'Mamba Forever',
        date: '02/02/2023',
        location: 'Prague, CZ',
        eventInfo: 'GOLDEN OAKS DAY DASH',
        prize: 60,
        claimed: true
    },
    {
        id: 3,
        time: '1m 22.53s',
        gate: 2,
        horse: 'Five Rings',
        jockey: 'Malik (Wise)',
        class: 3,
        place: 3,
        stable: "Thor's Breeding",
        guild: 'Mamba Forever',
        date: '02/02/2023',
        location: 'Prague, CZ',
        eventInfo: 'GOLDEN OAKS DAY DASH',
        prize: 60,
        claimed: true
    },
    {
        id: 4,
        time: '1m 22.53s',
        gate: 2,
        horse: 'Five Rings',
        jockey: 'Malik (Wise)',
        class: 3,
        place: 4,
        stable: "Thor's Breeding",
        guild: 'Mamba Forever',
        date: '02/02/2023',
        location: 'Prague, CZ',
        eventInfo: 'GOLDEN OAKS DAY DASH',
        prize: 60,
        claimed: false
    }
];
const Winnings = () => {
    const { t } = useTranslation();
    const [activePage, setActivePage] = useState(pageOptions[0].value);
    const nominationsList = chart
        .filter((item) => {
        if (activePage === pageOptions[0].value) {
            return true;
        }
        if (activePage === pageOptions[1].value) {
            return !item.claimed;
        }
        return item.claimed;
    })
        .map((item) => {
        return {
            date: (_jsx(Paragraph, { title: moment(item.date).format('MM/DD/YYYY'), size: 2, fontFamily: "marope" })),
            location: (_jsxs("div", { children: [_jsx(Heading, { title: item.eventInfo.toLocaleUpperCase(), size: 5, fontWeight: 600 }), _jsx(Paragraph, { title: item.location, size: 1, fontFamily: "urbanist", color: "grey" })] })),
            img: (_jsxs("div", Object.assign({ className: 'position-relative' }, { children: [_jsx("img", { src: Horse, className: styles.horseImg }), _jsx("img", { src: Jockey, className: styles.jockeyImg })] }))),
            racehorse: (_jsxs("div", { children: [_jsx(Paragraph, { className: styles.racehorse, title: item.horse.toLocaleUpperCase(), size: 2, fontFamily: 'marope' }), _jsx(Paragraph, { title: `& ${item.jockey}`, size: 1, color: 'grey', fontFamily: 'urbanist' })] })),
            place: _jsx(Paragraph, { title: item.place, size: 2, fontFamily: "marope" }),
            prize: (_jsxs("div", Object.assign({ className: 'd-flex align-items-center' }, { children: [_jsx(AdaBigIcon, { className: styles.icon }), _jsx(Paragraph, { title: item.prize, size: 2, fontFamily: 'marope', className: styles.cellText })] }))),
            btn: (_jsx(Button, { text: item.claimed ? 'Claimed' : 'Claim', size: 'xs', height: 'sm', color: 1, borderRadius: true, className: cn(), onClick: () => null, disabled: item.claimed }))
        };
    });
    return (_jsxs("div", Object.assign({ className: cn(styles.container) }, { children: [_jsx(Paragraph, { title: t('winnings'), size: 3, fontFamily: "urbanist" }), _jsxs("div", Object.assign({ className: cn(styles.cardsContainer) }, { children: [_jsx(WinningCard, { title: t('total_won'), coinsCount: 54376, leftContent: _jsx(Paragraph, { title: `+ ${157} ADA`, size: 2, color: "green", fontFamily: "marope" }) }), _jsx(WinningCard, { title: t('transfer_to_wallet'), coinsCount: 376, leftContent: _jsx(Button, { color: 2, text: t('transfer').toLocaleUpperCase(), onClick: () => null }) })] })), _jsxs("div", Object.assign({ className: cn('d-flex justify-content-between') }, { children: [_jsx(Paragraph, { title: t('races'), size: 3, fontFamily: "urbanist" }), _jsx("div", Object.assign({ className: cn(styles.buttons, 'd-flex align-items-center') }, { children: pageOptions.map((it) => {
                            return (_jsx(Button, { text: it.name, size: '100', height: 'sm', color: 1, borderRadius: true, className: cn(activePage !== it.value && styles.active), onClick: () => setActivePage(it.value) }, it.name));
                        }) }))] })), _jsx("div", Object.assign({ className: cn(styles.tab) }, { children: _jsx(Table, { columns: columns, tableData: nominationsList, className: styles.table }) }))] })));
};
export default Winnings;
